/* Geschenk-Abo-Konfigurator (Coffee Club 3/6/12 Monate).
   Varianten, Preise und Abo-Plan stehen pro Laufzeit als JSON im Snippet gift-club-config (live aus Shopify).
   Das Formular schickt id + selling_plan an /cart/add. Texte DE + EN, dynamische Knoten sind von Weglot ausgenommen. */
(function () {
  var html = document.documentElement;
  var EN = /^en/i.test(html.getAttribute('lang') || '') || /^\/en(\/|$)/.test(location.pathname);
  var T = EN ? {
    months: 'months',
    coffees: function (m) { return m + ' coffees of 250 g'; },
    perBag: 'per bag',
    grind: {
      'ganze Bohne': 'Whole bean', 'V60': 'Ground for V60', 'Chemex': 'Ground for Chemex', 'Moccamaster': 'Ground for Moccamaster',
      'Frenchpress': 'Ground for French press', 'Espresso Maschine': 'Ground for espresso machine', 'Bialetti': 'Ground for moka pot'
    }
  } : {
    months: 'Monate',
    coffees: function (m) { return m + ' Kaffees à 250 g'; },
    perBag: 'pro Tüte',
    grind: {
      'ganze Bohne': 'Ganze Bohne', 'V60': 'Gemahlen für V60', 'Chemex': 'Gemahlen für Chemex', 'Moccamaster': 'Gemahlen für Moccamaster',
      'Frenchpress': 'Gemahlen für French Press', 'Espresso Maschine': 'Gemahlen für Siebträger', 'Bialetti': 'Gemahlen für Bialetti'
    }
  };
  function label(g) { return T.grind[g] || g; }
  // Zeilen brechen nur an den Punkten um, nicht mitten in „250 g“ oder „pro Tüte“
  function nb(s) { return String(s).replace(/ /g, '\u00a0'); }

  function init(root) {
    if (!root || root.getAttribute('data-gcc-ready')) return;
    root.setAttribute('data-gcc-ready', '1');
    var plans = {};
    Array.prototype.forEach.call(root.querySelectorAll('script[data-gcc-plan]'), function (s) {
      try { plans[s.getAttribute('data-gcc-plan')] = JSON.parse(s.textContent); } catch (e) {}
    });
    var mIn = root.querySelectorAll('[data-gcc-m]');
    var rIn = root.querySelectorAll('[data-gcc-r]');
    var grind = root.querySelector('[data-gcc-grind]');
    var idIn = root.querySelector('[data-gcc-id]');
    var spIn = root.querySelector('[data-gcc-sp]');
    var price = root.querySelector('[data-gcc-price]');
    var line = root.querySelector('[data-gcc-line]');
    var per = root.querySelector('[data-gcc-per]');
    var btn = root.querySelector('[data-gcc-btn]');
    var na = root.querySelector('[data-gcc-na]');
    var live = root.querySelector('[data-gcc-live]');
    var cur = root.getAttribute('data-currency') || 'EUR';
    var loc = EN ? 'en-GB' : 'de-DE';
    if (!grind || !idIn) return;

    function money(cents) {
      try { return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
    }
    function checked(list) {
      for (var i = 0; i < list.length; i++) { if (list[i].checked) return list[i].value; }
      return list[0] ? list[0].value : null;
    }
    function grinds(plan, roast) {
      var out = [];
      plan.v.forEach(function (v) { if (v.r === roast && out.indexOf(v.g) < 0) out.push(v.g); });
      return out;
    }
    function fill(plan, roast) {
      var keep = grind.value;
      var opts = grinds(plan, roast);
      grind.innerHTML = '';
      opts.forEach(function (g) {
        var o = document.createElement('option');
        o.value = g;
        o.textContent = label(g);
        grind.appendChild(o);
      });
      grind.value = opts.indexOf(keep) > -1 ? keep : opts[0];
    }
    function update(say) {
      var m = checked(mIn), r = checked(rIn), plan = plans[m];
      if (!plan) return;
      if (grind.getAttribute('data-for') !== r + '|' + m) {
        fill(plan, r);
        grind.setAttribute('data-for', r + '|' + m);
      }
      var g = grind.value, v = null;
      plan.v.forEach(function (x) { if (x.r === r && x.g === g) v = x; });
      if (!v) return;
      idIn.value = v.id;
      if (spIn) spIn.value = plan.sp || '';
      if (price) price.textContent = v.p;
      if (line) line.textContent = nb(m + ' ' + T.months) + ' · ' + nb(r) + ' · ' + nb(label(g));
      if (per) per.textContent = nb(T.coffees(m)) + ' · ' + nb((v.b || money(Math.round(v.c / Number(m)))) + ' ' + T.perBag);
      if (btn) btn.disabled = !v.a;
      if (na) na.hidden = !!v.a;
      if (say && live) live.textContent = (line ? line.textContent : '') + ': ' + v.p;
    }
    Array.prototype.forEach.call(mIn, function (i) { i.addEventListener('change', function () { update(true); }); });
    Array.prototype.forEach.call(rIn, function (i) { i.addEventListener('change', function () { update(true); }); });
    grind.addEventListener('change', function () { update(true); });
    update(false);
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-gcc]'), init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) Array.prototype.forEach.call(e.target.querySelectorAll('[data-gcc]'), init);
  });
})();
